import { Directive, effect, HostBinding, HostListener, input, signal } from '@angular/core';
import {
  DEFAULT_FALLBACK_COLOR,
  DEFAULT_FONT_SIZE,
  FALLBACK_BRAND_NAME,
  FallbackColor,
  getSvgBrandLogo,
} from '../utils/svg.util';

@Directive({
  selector: 'img[logoFallback]',
  standalone: true,
  host: {
    '(error)': 'onError()',
    '[src]': 'currentSrc()',
  },
})
export class BrandLogoFallbackDirective {
  inputSrc = input<string | null>('');
  brandName = input<string>(FALLBACK_BRAND_NAME);
  fallbackColor = input<FallbackColor>(DEFAULT_FALLBACK_COLOR);
  fallbackFontSize = input<number>(DEFAULT_FONT_SIZE);

  protected currentSrc = signal<string | null>(this.inputSrc());

  constructor() {
    effect(() => {
      this.currentSrc.set(this.inputSrc() ?? '');
    });
  }

  onError(): void {
    this.currentSrc.set(getSvgBrandLogo(this.brandName(), this.fallbackColor(), this.fallbackFontSize()));
  }
}
